/*
 * SpurtCommerce
 * version 3.0
 * http://www.spurtcommerce.com
 *
 * Copyright (c) 2019 PICCOSOFT
 * Author piccosoft <support@spurtcommerce.com>
 * Licensed under the MIT license.
 */

export class DetailResponseModel {
  public productId: number;
  public sku: string;
  public upc: string;
  public location: string;
  public quantity: number;
  public minimumQuantity: number;
  public subtractStock: number;
  public stockStatusId: number;
  public manufacturerId: string;
  public shipping: string;
  public dateAvailable: string;
  public sortOrder: string;
  public price: number;
  public name: string;
  public description: string;
  public metaTagTitle: string;
  public condition: string;
  public isActive: number;
  public Category: any;
  public productImage: any;
  public relatedProductDetail: any;
  public productOption: any;
  public productDiscount: any;
  public productSpecialPrice: any;
  public pricerefer: number;
  public productFieldDev: any;
  
  public unidad_medida:any;
  public cancelar_cantidad:any;
  public medida_largo:any;
  public medida_alto:any;
  public medida_ancho:any;
  public medida_fija:any;
  public producto_medible:any;
  public nombre_unidad:any;

  public minima_cantidad:any;
  public cantidad_inicial:any;
  public incremento:any;
  public cantidad_prohibida:any;
  public clavesat:any;
  public dinamico:any;
  public tiene_disenio: any;
  public es_instalable: any;
  public ignorar_medida_metrica: any;

  
  constructor(detailResponse: any) {
    this.productId = detailResponse.productId || 0;
    this.sku = detailResponse.sku || '';
    this.upc = detailResponse.upc || '';
    this.location = detailResponse.location || '';
    this.shipping = detailResponse.shipping || '';
    this.dateAvailable = detailResponse.dateAvailable || '';
    this.sortOrder = detailResponse.sortOrder || '';
    this.quantity = detailResponse.quantity || 0;
    this.minimumQuantity = detailResponse.minimumQuantity || 0;
    this.subtractStock = detailResponse.subtractStock || 0;
    this.stockStatusId = detailResponse.stockStatusId || 0;
    this.manufacturerId = detailResponse.manufacturerId || 0;
    this.price = detailResponse.price || 0;
    this.name = detailResponse.name || '';
    this.description = detailResponse.description || '';
    this.metaTagTitle = detailResponse.metaTagTitle || '';
    this.condition = detailResponse.condition || '';
    this.isActive = detailResponse.isActive || 0;
    this.Category = detailResponse.Category || [];
    this.productImage = detailResponse.productImage || [];
    this.relatedProductDetail = detailResponse.relatedProductDetail || [];
    this.productOption = detailResponse.productOption || [];
    this.productDiscount = detailResponse.productDiscountData || [];
    this.productSpecialPrice = detailResponse.productSpecialPrice || [];
    this.pricerefer = detailResponse.pricerefer || 0;
    this.productFieldDev=detailResponse.productFieldDev || '';

    this.unidad_medida = detailResponse.unidad_medida || '';
    this.cancelar_cantidad = detailResponse.cancelar_cantidad || '';
    this.medida_largo = detailResponse.medida_largo || '';
    this.medida_alto = detailResponse.medida_alto || '';
    this.medida_ancho = detailResponse.medida_ancho || '';
    this.medida_fija = detailResponse.medida_fija || '';
    this.producto_medible = detailResponse.producto_medible || '';
    this.nombre_unidad = detailResponse.nombre_unidad || '';

    this.minima_cantidad = detailResponse.minima_cantidad || '';
    this.cantidad_inicial = detailResponse.cantidad_inicial || '';
    this.incremento = detailResponse.incremento || '';
    this.cantidad_prohibida = detailResponse.cantidad_prohibida || '';
    this.clavesat = detailResponse.clavesat || '';
    this.dinamico=detailResponse.dinamico||0;
    this.tiene_disenio=detailResponse.tiene_disenio||0;
    this.es_instalable=detailResponse.es_instalable||0;
    this.ignorar_medida_metrica=detailResponse.ignorar_medida_metrica||0;
  }
}
